import type { Locale } from '@icetus/contracts';

/**
 * 语言的国旗小图标。
 *
 * 不用 emoji（🇨🇳 / 🇬🇧）：Windows 的 Chrome 与 Edge 不带国旗字体，
 * 会把 🇬🇧 显示成「GB」两个字母方块 —— 而国内客户的电脑基本全是 Windows。
 * 自己画 4 个 SVG 只有几十行，在任何系统上都长一个样。
 *
 * 语言不是国家（`en` 不等于英国、`ar` 覆盖二十多个国家），这里只是给
 * 「哪一门语言」配一个一眼认得出的色块，不承担地图含义；所以 `en` 取
 * 最通用的英文标识（米字旗），代码仍以文字标在旁边。
 *
 * 尺寸固定 18×12（3:2）。小到这个程度只剩色块可辨，细节一律省略。
 */
export function LocaleFlag({ locale }: { locale: Locale }) {
  return (
    <svg
      className="locale-flag"
      viewBox="0 0 18 12"
      width="18"
      height="12"
      aria-hidden="true"
      focusable="false"
    >
      {locale === 'zh' ? (
        <>
          <rect width="18" height="12" fill="#de2910" />
          {/* 一颗大星足够认出是中国；五颗小星在 18×12 里会糊成一片噪点 */}
          <path
            transform="translate(1.6 1.5) scale(0.38)"
            d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
            fill="#ffde00"
          />
        </>
      ) : null}
      {locale === 'en' ? (
        <>
          <rect width="18" height="12" fill="#012169" />
          {/* 米字旗：白色对角 + 白色十字，红色叠在上面 */}
          <path d="M0 0l18 12M18 0L0 12" stroke="#ffffff" strokeWidth="2.6" />
          <path d="M0 0l18 12M18 0L0 12" stroke="#c8102e" strokeWidth="1" />
          <path d="M9 0v12M0 6h18" stroke="#ffffff" strokeWidth="3.6" />
          <path d="M9 0v12M0 6h18" stroke="#c8102e" strokeWidth="2" />
        </>
      ) : null}
      {locale === 'es' ? (
        <>
          {/* 西班牙：红-黄-红，中间那条是两倍高 */}
          <rect width="18" height="12" fill="#aa151b" />
          <rect y="3" width="18" height="6" fill="#f1bf00" />
        </>
      ) : null}
      {locale === 'ar' ? (
        <>
          {/* 沙特：绿底 + 白色横条。真旗上有清真言与宝剑，这个尺寸下只能是两笔 */}
          <rect width="18" height="12" fill="#006c35" />
          <path
            d="M3.2 5.2h11.6M5 8.1h8"
            stroke="#ffffff"
            strokeWidth="1.1"
            strokeLinecap="round"
          />
        </>
      ) : null}
    </svg>
  );
}
